/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable */

window.PXUTheme.jsAjaxCart = {
  init: function ($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsAjaxCart = $.extend(this, window.PXUTheme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.showDrawer();

        return false;
      });

    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const isKeyboardClick = e.detail === 0 || e.pointerType === '';
      const $addToCartForm = $(this).closest('form');
      window.PXUTheme.jsAjaxCart.addToCart($addToCartForm, isKeyboardClick);

      return false;
    });

    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).parents('[data-line-item]').data('line-item');
      window.PXUTheme.jsAjaxCart.removeFromCart(lineID);

      if (window.PXUTheme.jsCart) {
        window.PXUTheme.jsCart.removeFromCart(lineID);
      }

      return false;
    });

    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      window.PXUTheme.jsAjaxCart.hideDrawer();
      window.PXUTheme.jsAjaxCart.hideMiniCart();

      return false;
    });

    $(document).on('keydown', '[data-ajax-cart-close]', function (e) {
      if (e.which === 13) { // Enter key
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.hideDrawer();
        window.PXUTheme.jsAjaxCart.hideMiniCart();

        return false;
      }
    });

  },
  showMiniCartOnHover: function () {
    const $el = $('[data-ajax-cart-trigger]');

    $el.hover(function() {
      if(window.PXUTheme.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
      window.PXUTheme.jsAjaxCart.setupFocusTrap();
    }, function() {
      // Small timeout to allow focus to land if user is tabbing while moving mouse
      setTimeout(() => {
        if ($el.find(':focus').length || $el.is(':focus')) {
          return;
        }
        $el.removeClass('show-mini-cart');
        $(document).off('.ajaxCartTrap');
      }, 100);
    });
  },
  hideMiniCart: function () {
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function() {
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    // Removes url to the cart page so user is not redirected
    $el.attr('href', '#');

    $el.off('touchstart').on('touchstart', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      }

      // Loads content into ajaxCart container for mobile header
      window.PXUTheme.jsAjaxCart.initializeAjaxCartOnMobile();

      // If user clicks outside the element, toggle the mini cart
      $el.toggleClass('show-mini-cart');
      if ($el.hasClass('show-mini-cart')) {
        window.PXUTheme.jsAjaxCart.setupFocusTrap();
      }
    });
  },
  showDrawer: function (isKeyboardClick) {
    if (this.cart_action == 'drawer') {
      this.ajaxCartDrawer.addClass('is-visible');
      $('.ajax-cart__overlay').addClass('is-visible');
    } else if (this.cart_action == 'mini_cart') {
      $('[data-ajax-cart-trigger]').addClass('show-mini-cart');
    }

    if (isKeyboardClick) {
      window.PXUTheme.jsAjaxCart.setupFocusTrap();
    }
  },
  hideDrawer: function () {
    if (this.ajaxCartDrawer) {
      this.ajaxCartDrawer.removeClass('is-visible');
    }
    $('.ajax-cart__overlay').removeClass('is-visible');
    $('[data-ajax-cart-trigger]').removeClass('show-mini-cart');
  },
  hideMiniCart: function () {
    $('[data-ajax-cart-trigger]').removeClass('show-mini-cart');
  },
  removeFromCart: function (lineID, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        window.PXUTheme.jsAjaxCart.updateView();
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  },
  initializeAjaxCart: function () {

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('[data-ajax-cart-content]').html(html.content);

        // Converting the currencies
        if (window.PXUTheme.currencyConverter) {
          window.PXUTheme.currencyConverter.convertCurrencies();
        }
        
        window.PXUTheme.jsAjaxCart.enhanceAccessibility();

      })
      .fail(() => {
        // some error handling
      });
  },
  initializeAjaxCartOnMobile: function () {

    this.toggleMiniCart();

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('.mobile-header [data-ajax-cart-content]').html(html.content);
        window.PXUTheme.jsAjaxCart.enhanceAccessibility();

      })
      .fail(() => {
        // some error handling
      });
  },
  addToCart: function ($addToCartForm, isKeyboardClick) {
    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
    this.recipientForm = $addToCartForm[0].querySelector('[data-recipient-form]');

    if (this.recipientForm) {
      this.recipientForm.classList.remove('recipient-form--has-errors');
    }

    $addToCartForm.removeClass('shopify-product-form--unselected-error');

    if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
      const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;

      $('.warning').remove();

      $addToCartForm
        .addClass('shopify-product-form--unselected-error')
        .find('.cart-warning')
        .html(cartWarning);

      $addToCartBtn
        .removeAttr('disabled')
        .removeClass('disabled');

      $addToCartBtn.find('.icon')
        .removeClass('zoomOut')
        .addClass('zoomIn');

      $addToCartBtn
        .find('span:not(.icon)')
        .text($addToCartBtn.data('label'))
        .removeClass('zoomOut')
        .addClass('zoomIn');
    } else {
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function () {
          $addToCartBtn
            .attr('disabled', 'disabled')
            .addClass('disabled');

          $addToCartBtn.find('span')
            .removeClass("fadeInDown")
            .addClass('animated zoomOut');
        },
        success: function (product) {
          let $el = $('[data-ajax-cart-trigger]');

          $addToCartBtn
            .find('.checkmark')
            .addClass('checkmark-active');

          function addedToCart() {
            // Checkmark animation finishes here. 
            // We only handle cleanup of button state now.
            $addToCartBtn.find('span')
              .removeClass('fadeInDown');
          }

          window.setTimeout(function () {
            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.checkmark')
              .removeClass('checkmark-active');

            $addToCartBtn.find('.text, .icon')
              .removeClass('zoomOut')
              .addClass('fadeInDown');

            $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

          }, 1000);

          if (isKeyboardClick) {
            window.PXUTheme.jsAjaxCart.forceFocusOnNextUpdate = true;
          }
          window.PXUTheme.jsAjaxCart.showDrawer(isKeyboardClick);
          window.PXUTheme.jsAjaxCart.updateView();

          if (window.PXUTheme.jsCart) {
            $.ajax({
              dataType: "json",
              async: false,
              cache: false,
              dataType: 'html',
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);

              }
            });
          }

        },
        error: XMLHttpRequest => {
          const response = eval('(' + XMLHttpRequest.responseText + ')');

          $('.warning').remove();

          let cartWarning;

          if (response.errors && response.errors.email) {
            this.recipientForm.classList.add('recipient-form--has-errors');
          } else {
            cartWarning = `<p class="cart-warning__message animated bounceIn">${response.description.replace('All 1 ', 'All ')}</p>`;
          }

          $addToCartForm
            .find('.cart-warning')
            .html(cartWarning);

          $addToCartBtn
            .removeAttr('disabled')
            .removeClass('disabled');

          $addToCartBtn.find('.icon')
            .removeClass('zoomOut')
            .addClass('zoomIn');

          $addToCartBtn
            .find('span:not(.icon)')
            .text($addToCartBtn.data('label'))
            .removeClass('zoomOut')
            .addClass('zoomIn');
        }
      });
    }
  },
  updateView: function () {
    // 1. Save focus identity before replacement
    let focusIdentity = null;

    if (window.PXUTheme.jsAjaxCart && window.PXUTheme.jsAjaxCart.pendingFocusIdentity) {
      focusIdentity = window.PXUTheme.jsAjaxCart.pendingFocusIdentity;
      window.PXUTheme.jsAjaxCart.pendingFocusIdentity = null; // Clear immediately
    } else {
      const activeEl = document.activeElement;
      const $activeEl = $(activeEl);

      if ($activeEl.closest('[data-ajax-cart-content]').length) {
        const $product = $activeEl.closest('[data-cart-item]');
        if ($product.length) {
          // Capture specific context to find the exact same element after re-render
          focusIdentity = {
            itemKey: $product.data('cart-item'),
            lineItem: $product.data('line-item'),
            tagName: activeEl.tagName,
            className: activeEl.className,
            href: activeEl.getAttribute('href'),
            text: activeEl.textContent.trim(),
            // Special cases for quantity buttons
            isPlus: $activeEl.hasClass('quantity-plus'),
            isMinus: $activeEl.hasClass('quantity-minus'),
            isDelete: $activeEl.is('[data-ajax-cart-delete]') || $activeEl.hasClass('ajax-cart__delete')
          };
        }
      }
    }

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
    .done(({ html, options }) => {

      if (options.item_count > 0) {
        const itemList = $(html.content).find('.ajax-cart__list');
        const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');

        $('.ajax-cart__list').replaceWith(itemList);
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);

      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }

      if (window.PXUTheme.currencyConverter) {
        window.PXUTheme.currencyConverter.convertCurrencies();
      }

      window.PXUTheme.jsAjaxCart.enhanceAccessibility();

      // 2. Restore focus after replacement
      if (focusIdentity && (focusIdentity.itemKey || focusIdentity.lineItem)) {
        
        // ONLY search within the currently visible active cart container to avoid hidden mobile duplicates taking priority!
        const $activeContainer = $('[data-ajax-cart-drawer].is-visible, [data-ajax-cart-trigger].show-mini-cart').find('[data-ajax-cart-content]').filter(':visible').first();
        const searchScope = $activeContainer.length ? $activeContainer : $('[data-ajax-cart-content]');

        let $newProduct = searchScope.find(`[data-cart-item="${focusIdentity.itemKey}"]`);
        
        // Fallback robustly directly to the line-item index if the unique cart-item key rotated
        if (!$newProduct.length && focusIdentity.lineItem) {
          $newProduct = searchScope.find(`[data-line-item="${focusIdentity.lineItem}"]`);
        }

        if ($newProduct.length) {
          let $target;
          
          // Direct focus according to user requirement (keep it on the same interaction button type)
          if (focusIdentity.isPlus) $target = $newProduct.find('.quantity-plus');
          else if (focusIdentity.isMinus) $target = $newProduct.find('.quantity-minus');
          else if (focusIdentity.isDelete) $target = $newProduct.find('[data-ajax-cart-delete], .ajax-cart__delete');
          
          // Fallback: If no specific button was saved, try to match by class or tag (e.g. images, titles)
          if (!$target || !$target.length) {
             const selector = focusIdentity.tagName.toLowerCase() + (focusIdentity.className ? '.' + focusIdentity.className.split(' ').join('.') : '');
             const $matches = $newProduct.find(selector);
             
             // Try to find the exact match using href or text
             if ($matches.length > 1) {
               $matches.each(function() {
                 if (focusIdentity.href && this.getAttribute('href') === focusIdentity.href && this.textContent.trim() === focusIdentity.text) {
                   $target = $(this);
                   return false; // break
                 }
               });
             }
             
             if (!$target || !$target.length) {
               $target = $matches;
             }
          }

          if ($target && $target.length) {
            const focusTarget = $target[0];
            
            // Unconditionally apply initial focus instruction
            focusTarget.focus();
            
            // Engage a resilient focus retrier to defeat native DOM paint-lag or accessibility tree overrides
            let retries = 0;
            const focusLoop = setInterval(() => {
              if (document.activeElement === focusTarget || retries >= 4) {
                clearInterval(focusLoop);
              } else {
                focusTarget.focus();
                retries++;
              }
            }, 50);
            
            // Do not return here so focus trap can be reinstated below
          }
        }
      }

      // Reinstate focus trap if cart is visible
      if ($('[data-ajax-cart-trigger].show-mini-cart, [data-ajax-cart-drawer].is-visible').length) {
        window.PXUTheme.jsAjaxCart.setupFocusTrap();
        
        // If we just added an item via keyboard, move focus to the title immediately
        if (window.PXUTheme.jsAjaxCart.forceFocusOnNextUpdate) {
          window.PXUTheme.jsAjaxCart.forceFocusOnNextUpdate = false;
          window.PXUTheme.jsAjaxCart.focusCartTitle();
        }
      }
    })
    .fail(() => {
      // some error handling
    });
  },
  focusCartTitle: function () {
    let attempts = 0;
    const maxAttempts = 5;
    const interval = 200;

    const tryFocus = () => {
      // SAFETY CHECK: If focus is ALREADY inside the cart content area, 
      // do not hijack it. This prevents the "bounce-back" after 2-3 seconds.
      if ($('[data-ajax-cart-content]').find(document.activeElement).length) {
        return;
      }

      attempts++;
      // Re-prioritize the main cart title as requested
      const $title = $('.ajax-cart__cart-item-title').filter(':visible').first();

      if ($title.length) {
        $title.focus();
        if (document.activeElement !== $title[0] && attempts < maxAttempts) {
          setTimeout(tryFocus, interval);
        }
      } else if (attempts < maxAttempts) {
        setTimeout(tryFocus, interval);
      }
    };

    setTimeout(tryFocus, 400);
  },
  setupFocusTrap: function () {
    // 1. Identify the ONE truly active container
    // Prioritize the visible drawer or the active trigger's content
    const $activeContainer = $('[data-ajax-cart-drawer].is-visible, [data-ajax-cart-trigger].show-mini-cart').find('[data-ajax-cart-content]').filter(':visible').first();

    if (!$activeContainer.length) return;

    // Remove any existing trap listeners
    $(document).off('.ajaxCartTrap');

    const getFocusableEls = () => {
      // Find all standard interactive elements within the active container
      return $activeContainer.find('summary, a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"]), input:not([type="hidden"]), select, textarea')
        .filter(function() {
          const $el = $(this);
          // Only include elements that are actually visible and have physical presence
          return $el.is(':visible') && $el.css('visibility') !== 'hidden' && $el.css('opacity') !== '0' && $el.height() > 0;
        });
    };

    // Standard Tab-key Trap
    $(document).on('keydown.ajaxCartTrap', function (e) {
      if (e.key !== 'Tab') return;

      const focusableEls = getFocusableEls();
      if (!focusableEls.length) return;

      const firstChild = focusableEls[0];
      const lastChild = focusableEls[focusableEls.length - 1];

      if (e.shiftKey) { // Shift + Tab (Backward)
        if (document.activeElement === firstChild) {
          e.preventDefault();
          lastChild.focus();
        }
      } else { // Tab (Forward)
        if (document.activeElement === lastChild) {
          e.preventDefault();
          firstChild.focus();
        }
      }
    });

    // Handle closure cleanup
    $(document).on('click.ajaxCartTrap', '[data-ajax-cart-close], .ajax-cart__overlay', function() {
       $(document).off('.ajaxCartTrap');
    });

    $(document).on('keydown.ajaxCartTrap', function(e) {
      if (e.key === 'Escape') {
        $('[data-ajax-cart-trigger].show-mini-cart').removeClass('show-mini-cart');
        window.PXUTheme.jsAjaxCart.hideDrawer();
        
        // Wait for animations to finish before clearing trap
        setTimeout(() => {
          $(document).off('.ajaxCartTrap');
        }, 500);
      }
    });
  },
  enhanceAccessibility: function () {
    // Note: The user has restored this logic to ensure text nodes are wrapped for readability.
    $('.ajax-cart__taxes-shipping-message').each(function() {
      const $el = $(this);
      $el.contents().each(function() {
        if (this.nodeType === 3 && this.nodeValue.trim().length > 0) {
          $(this).replaceWith(`<span tabindex="0">${this.nodeValue}</span>`);
        }
      });
    });
  },
  unload: function ($section) {
    $(document).off('.ajaxCartTrap');
    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
    $('[data-ajax-cart-close]').off();
  }
}

/******/ })()
;